import useBuildVariantProps from '../../../modules/theme/useBuildVariantProps';
import { useControlledValue } from '../../molecules/FormField/useControlledValue';
import { TextAreaProps } from './TextArea.types';

const usePresenter = (props: TextAreaProps) => {
  const {
    value,
    onValueChange,
    disabled = false,
    invalid = false,
    required,
    ...otherTextAreaProps
  } = props;

  const { value: textAreaValue, onValueChange: handleValueChange } = useControlledValue({ value, onValueChange, defaultValue: '' });

  const onInputChanged = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    // updated value from change event object
    const updatedValue = event.target.value || '';
    handleValueChange(updatedValue);
  };

  const variantProps = useBuildVariantProps(
    'text-area',
    {},
    { 
      disabled,
      invalid,
    },
  );

  return {
    value: textAreaValue,
    onInputChanged,
    disabled,
    invalid,
    required,
    otherTextAreaProps,
    variantProps,
  }
};

export default usePresenter;